// Reuse Horizon's native controls, submissions and focus management.
export function openNativeLocalization(root = document) {
  const header = root.querySelector('#header-component');
  if (!header) return false;
  header.scrollIntoView({ behavior: 'instant', block: 'start' });
  const desktop = header.querySelector('.dropdown-localization');
  if (desktop?.getClientRects().length && getComputedStyle(desktop).display !== 'none') {
    const trigger = desktop.querySelector('[ref="button"]');
    if (trigger && typeof desktop.showPanel === 'function') {
      desktop.showPanel();
      (desktop.querySelector('[ref="search"]') || desktop.querySelector('select') || trigger).focus();
      return true;
    }
    const language = desktop.querySelector('select');
    if (language) { language.focus(); return true; }
  }
  const drawer = [...header.querySelectorAll('header-drawer')].find(element => element.getClientRects().length && getComputedStyle(element).display !== 'none');
  if (!drawer) return false;
  const menu = drawer.querySelector('details.menu-drawer-container');
  const region = drawer.querySelector('drawer-localization-component details');
  const menuTrigger = menu?.querySelector(':scope > summary');
  if (!menu || !menuTrigger) return false;
  if (!menu.open) menuTrigger.click();
  if (region) {
    if (!region.open) region.querySelector(':scope > summary')?.click();
    (region.querySelector('[ref="search"]') || region.querySelector('select') || region.querySelector('summary'))?.focus();
  } else {
    drawer.querySelector('.menu-drawer__localization select')?.focus();
  }
  return true;
}

class LocalizationLink extends HTMLElement {
  connectedCallback() { this.addEventListener('click', this.open); }
  disconnectedCallback() { this.removeEventListener('click', this.open); }
  open = (event) => {
    if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    // Do not let this footer click become the newly opened native panel's outside click.
    event.stopPropagation();
    if (openNativeLocalization()) event.preventDefault();
  };
}
if (!customElements.get('tbwl-localization-link')) customElements.define('tbwl-localization-link', LocalizationLink);
